import {index, store, appearOnline, appearOffline, countOnlineCatchers} from '@/api/messages';

// States.
export const state = {
  opened: false,
  messages: [],
  fetching: false,
  message: '',
  onlineUsers: 0,
}

// Getters.
export const getters = {
  onlineCatchers: state => state.onlineUsers,
  messages: state => state.messages,
  chatBoxIsOpened: state => state.opened,
  chatBoxIsClosed: state => !state.opened,
  fetchingMessages: state => state.fetching,
  currentMessage: state => state.message,
}

// Mutations.
export const mutations = {
  UPDATE_OPENED: (state, opened) => state.opened = opened,
  SET_FETCHING: (state, fetching) => state.fetching = fetching,
  SET_MESSAGES: (state, messages) => state.messages = messages,
  SET_CURRENT_MESSAGE: (state, message) => state.message = message,
  APPEND_MESSAGE: (state, message) => state.messages.push(message),
  SET_ONLINE_USERS: (state, onlineUsers) => state.onlineUsers = onlineUsers,
}

// Actions.
export const actions = {
  openChatBox: ({commit}) => commit('UPDATE_OPENED', true),
  closeChatBox: ({commit}) => commit('UPDATE_OPENED', false),

  setCurrentMessage: ({commit}, message) => commit('SET_CURRENT_MESSAGE', message),

  fetchMessages: async ({commit}, {experiment}) => {
    commit('SET_FETCHING', true);
    let {data: {data}} = await index({experiment});
    commit('SET_MESSAGES', data);
    commit('SET_FETCHING', false);
  },

  updateOnlineUsers: async ({commit}, {experiment}) => {
    let {data: {count}} = await countOnlineCatchers({experiment});
    commit('SET_ONLINE_USERS', count);
  },

  userLoggedOn: async ({commit}, {experiment}) => await appearOnline({experiment}),

  userLoggedOff: async ({commit}, {experiment}) => await appearOffline({experiment}),

  receivedMessage: ({commit}, {message}) => commit('APPEND_MESSAGE', message),

  sendMessage: async ({commit, state}, {experiment}) => {
    let message = state.message;
    commit('SET_CURRENT_MESSAGE', '');
    let {data: {data}} = await store({experiment, message});
    commit('APPEND_MESSAGE', data);
  }
}
